"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.Dropdown = void 0;
var observable_1 = require("../helper/observable");
var element_from_string_1 = require("../utils/element-from-string");
var Dropdown = /** @class */ (function (_super) {
    __extends(Dropdown, _super);
    function Dropdown(select, options) {
        var _this = _super.call(this) || this;
        _this.core = select;
        _this.options = options;
        return _this;
    }
    Dropdown.prototype.render = function () {
        this.dropdown = element_from_string_1.elementFromString('<span class="select2-dropdown"><span class="select2-results"></span></span>');
        this.dropdown.setAttribute('dir', this.options.get('dir'));
        return this.dropdown;
    };
    Dropdown.prototype.binding = function (select, container) {
        // Should be implemented in subclasses
    };
    Dropdown.prototype.position = function (dropdown, container) {
        // Should be implemented in subclasses
    };
    Dropdown.prototype.destroy = function () {
        this.dropdown.remove();
    };
    return Dropdown;
}(observable_1.Observable));
exports.Dropdown = Dropdown;
//# sourceMappingURL=dropdown.js.map